import fileSys from "../fileoprators/fileSystem";
import { objectCopy } from "../shared/utils";
import SettingsOprator from "./settingsoprator";
const DEFAULTSET = {
  language: "zh_CN",
  dateFormat: "yyyymmdd_line",
  sort: {
    key: "creationdate",
    asc_desc: -1
  },
  audio: {
    value: 0,
    mute: true
  },
  screensavetime: 5,
  timeZone: {
    zone: "Asia",
    city: "Shanghai"
  },
  sharedFolder: {
    username: "",
    ip: "",
    folder: "",
    password: "",
    folderInLinux: "/home/mw520/shared_folder",
    enabled: false
  },
  thirdparty: {
    enabled: false,
    copmany: "mediworks",
    btnKey: "login",
    downloadUrl: "http://47.98.209.109:8088/thirdparty_scripts"
  },
  expertMode: false,
  netSelect: "dhcp"
};
class GlobalSettings extends SettingsOprator {
  constructor() {
    super(fileSys.getCfgPath("settings.json"), DEFAULTSET);
  }
  getGlobalSettings() {
    return this.getSettings();
  }
  saveGlobalSettings(settings) {
    this.saveSettings(settings);
  }
  restore() {
    window.settings = objectCopy(DEFAULTSET);
    this.saveSettings(window.settings);
  }
}
export default GlobalSettings;



// WEBPACK FOOTER //
// ./src/settings/globalsettings.js